import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Discover from "@/pages/Discover";
import ExperienceDetail from "@/pages/ExperienceDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import HostDashboard from "@/pages/HostDashboard";
import TravelerDashboard from "@/pages/TravelerDashboard";
import Preferences from "@/pages/Preferences";
import CreateExperience from "@/pages/CreateExperience";
import BookingSuccess from "@/pages/BookingSuccess";
import ForHosts from "@/pages/ForHosts";
import { MessagesList, MessageThread } from "@/pages/Messages";
import Favorites from "@/pages/Favorites";
import AdminDashboard from "@/pages/AdminDashboard";

function AppRouter() {
  const location = useLocation();
  // Handle Google OAuth callback synchronously before any protected route runs
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/discover" element={<Discover />} />
      <Route path="/experience/:id" element={<ExperienceDetail />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/for-hosts" element={<ForHosts />} />
      <Route path="/host" element={<HostDashboard />} />
      <Route path="/host/new" element={<CreateExperience />} />
      <Route path="/host/edit/:id" element={<CreateExperience />} />
      <Route path="/traveler" element={<TravelerDashboard />} />
      <Route path="/preferences" element={<Preferences />} />
      <Route path="/booking/success" element={<BookingSuccess />} />
      <Route path="/messages" element={<MessagesList />} />
      <Route path="/messages/:threadId" element={<MessageThread />} />
      <Route path="/favorites" element={<Favorites />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster richColors position="top-center" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
